var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push"},[_c('v-btn',{on:{"click":_vm.pushMoreData}},[_vm._v("Add Data")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }